import { createSelector } from "@reduxjs/toolkit";
import { helpers } from "../../../packages/helpers";
import { authSelectors } from "../../auth";
import { selectChatMessages } from "./select-chat-messages";
import { selectChatSettings } from "./select-chat-settings";

const { selectUserId } = authSelectors;
const { isMessageReceived } = helpers.predicates;

export const selectUnreadMessagesCount = createSelector(
  selectChatSettings,
  selectChatMessages,
  selectUserId,
  ({ lastReadMessageIndex }, messages, userId) =>
    messages
      .slice(lastReadMessageIndex + 1)
      .filter(
        (message) =>
          message.authorId !== userId && isMessageReceived(message.status)
      ).length
);
